export interface InterstitialData {
  icon: "trending" | "users" | "target";
  title: string;
  stats: {
    number: string;
    label: string;
  }[];
  description: string;
}

export const interstitials: Record<number, InterstitialData> = {
  4: {
    icon: "users",
    title: "Czy wiesz, że...",
    stats: [
      { number: "+500 tys.", label: "Decydentów w Polsce" },
      { number: "+900M", label: "Użytkowników na świecie" },
      { number: "61M", label: "Firm na LinkedIn" }
    ],
    description: "LinkedIn to największa profesjonalna globalna platforma biznesowa, dzięki której możesz dotrzeć ze swoją ofertą do tysięcy decydentów w Polsce i milionów na świecie"
  },
  6: {
    icon: "target",
    title: "Czy wiesz, że...",
    stats: [
      { number: "+500", label: "Kryteriów wyszukiwania" },
      { number: "3x", label: "Większa skuteczność pozyskania leadów" },
      { number: "45%", label: "Wyższe współczynniki konwersji" }
    ],
    description: "LinkedIn Sales Navigator do jedno z najlepszych narządzi prospecting'owych, pozwala precyzyjnie budować bazę potencjalnych klientów, skutecznie docierać do decydentów i nawiązywać z nimi relacje."
  },
  9: {
    icon: "trending",
    title: "Czy wiesz, że...",
    stats: [
      { number: "5x", label: "Większy zasięg niż strony firmowe" },
      { number: "3x", label: "Więcej zaangażowania" },
      { number: "2x", label: "Wyższe współczynniki konwersji" }
    ],
    description: "Treści publikowane przez pracowników generują znacznie lepsze rezultaty niż oficjalne kanały firmowe."
  },
  12: {
    icon: "target",
    title: "Czy wiesz, że...",
    stats: [
      { number: "75%", label: "Profili ma adres email" },
      { number: "60%", label: "Profili ma numer telefonu" },
      { number: "5x", label: "Wyższa skuteczność z AI 1:1" }
    ],
    description: "Z LinkedIna możesz zdobyć firmowy email i numer telefonu niemal każdej osoby. Połączenie tego z AI, automatyzacją i cold mailingiem daje znacznie lepsze wyniki niż tradycyjne metody pozyskiwania klientów."
  }
};